import React from "react";
import styles from "./Skeleton.module.css";

export const Skeleton: React.FC<{ width?: number }> = (props) => {
  return (
    <div
      className={styles.Skeleton}
      style={{ width: props.width && `${props.width}%` }}
    />
  );
};
